export default class RootCauseAnswerModel {
  public extensionRootCauseAnswerId: string = ''
  public rootMapId: string = ''
  public extensionInvestigationId: string = ''
  public rootMapDetail: string = ''

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
